<template>
  <div>
    <h4 class="mb-3 pb-3 border-bottom">
      Dane dziecka
    </h4>
    <validation-observer
      ref="patients-form-general"
      tag="form">
    <d-row>
      <d-col cols="3" md="2" lg="4">
        <div class="form-group">
          <label for="patient-sex">
            Płeć:
          </label>
          <validation-provider
            :rules="'required'"
            name="patient-sex"
            v-slot="{ errors }">
            <div
              :class="{
                'form-control': true,
                'is-select': true,
                'is-invalid': errors.length
              }">
              <v-select
                v-model="data.sex"
                :options="sexType"
                :reduce="sex => sex.value"
                :state="errors.length ? 'invalid' : null"
                label="name"
                name="patient-sex"
                placeholder="Wybierz płeć" >
              </v-select>
            </div>
            <div class="invalid-feedback">
              {{ errors[0] }}
            </div>
          </validation-provider>
        </div>
      </d-col>
      <d-col cols="3" md="2" lg="4">
        <div class="form-group">
          <label for="patient-name">
            Imię:
          </label>
          <validation-provider
            rules="required"
            name="patient-name"
            v-slot="{ errors }">
            <d-input
              id="patient-name"
              v-model="data.name"
              :state="errors.length ? 'invalid' : null" />
            <div class="invalid-feedback">
              {{ errors[0] }}
            </div>
          </validation-provider>
        </div>
      </d-col>
      <d-col cols="3" md="2" lg="4">
        <div class="form-group">
          <label for="patient-last-name">
            Nazwisko:
          </label>
          <validation-provider
            rules="required"
            name="patient-last-name"
            v-slot="{ errors }">
            <d-input
              id="patient-last-name"
              v-model="data.last_name"
              :state="errors.length ? 'invalid' : null" />
            <div class="invalid-feedback">
              {{ errors[0] }}
            </div>
          </validation-provider>
        </div>
      </d-col>
    </d-row>
    <d-row>
      <d-col cols="3" md="2" lg="6">
        <div class="form-group">
          <label for="patient-birthday">
            Data urodzin:
          </label>
          <validation-provider
            rules="required"
            name="patient-birthday"
            v-slot="{ errors }">
            <d-input
              id="patient-birthday"
              type="date"
              v-model="data.birthday_date"
              :state="errors.length ? 'invalid' : null" />
            <div class="invalid-feedback">
              {{ errors[0] }}
            </div>
          </validation-provider>
        </div>
      </d-col>
      <d-col cols="3" md="2" lg="6">
        <div class="form-group">
          <label for="patient-place-of-birth">
            Miejsce urodzenia:
          </label>
          <validation-provider
            rules="required"
            name="patient-place-of-birth"
            v-slot="{ errors }">
            <d-input
              id="patient-place-of-birth"
              v-model="data.place_of_birth"
              :state="errors.length ? 'invalid' : null" />
            <div class="invalid-feedback">
              {{ errors[0] }}
            </div>
          </validation-provider>
        </div>
      </d-col>
    </d-row>
    <div class="form-group">
      <label for="patient-pesel">
        PESEL:
      </label>
      <validation-provider
      rules="required"
      name="patient-pesel"
      immediate
      v-slot="{ errors }">
        <pesel-search
          peselId="patient-pesel"
          v-model="data.pesel"
          :options="peselOptions"
          :loading="peselLoading"
          :state="errors.length ? 'invalid' : null"
          @search="searchByPesel"
          @selected="openModal"
        />
        <div class="invalid-feedback">
          {{ errors[0] }}
        </div>
      </validation-provider>
    </div>
    <d-row>
      <d-col cols="2" md="2" lg="6">
        <div class="form-group">
          <label for="patient-city">
            Miasto:
          </label>
          <validation-provider
            rules="required"
            name="patient-city"
            v-slot="{ errors }">
            <d-input
              id="patient-city"
              type="text"
              v-model="data.city"
              :state="errors.length ? 'invalid' : null" />
            <div class="invalid-feedback">
              {{ errors[0] }}
            </div>
          </validation-provider>
        </div>
      </d-col>
      <d-col cols="2" md="2" lg="6">
        <div class="form-group">
          <label for="patient-post-code">
            Kod pocztowy:
          </label>
          <validation-provider
            rules="required"
            name="patient-post-code"
            v-slot="{ errors }">
            <d-input
              id="patient-post-code"
              v-model="data.post_code"
              :state="(errors.length) ? 'invalid' : null" />
            <div class="invalid-feedback">
              {{ errors[0] }}
            </div>
          </validation-provider>
        </div>
      </d-col>
    </d-row>
    <d-row>
      <d-col cols="3" md="3" lg="4">
        <div class="form-group">
          <label for="patient-street">
            Ulica:
          </label>
          <validation-provider
            name="patient-street"
            v-slot="{ errors }">
            <d-input
              id="patient-street"
              v-model="data.street"
              :state="(errors.length) ? 'invalid' : null" />
            <div class="invalid-feedback">
              {{ errors[0] }}
            </div>
          </validation-provider>
        </div>
      </d-col>
      <d-col cols="3" md="3" lg="4">
        <div class="form-group">
          <label for="patient-number-home">
            Numer domu:
          </label>
          <validation-provider
            name="patient-number-home"
            v-slot="{ errors }">
            <d-input
              id="patient-number-home"
              v-model="data.number_home"
              :state="(errors.length) ? 'invalid' : null" />
            <div class="invalid-feedback">
              {{ errors[0] }}
            </div>
          </validation-provider>
        </div>
      </d-col>
      <d-col cols="3" md="3" lg="4">
        <div class="form-group">
          <label for="patient-number-local">
            Numer lokalu:
          </label>
          <validation-provider
            v-slot="{ errors }">
            <d-input
              id="patient-number-local"
              type="text"
              format="[0-9]{2}\-[0-9]{3}"
              v-model="data.number_local"
              :state="errors.length ? 'invalid' : null" />
            <div class="invalid-feedback">
              {{ errors[0] }}
            </div>
          </validation-provider>
        </div>
      </d-col>
    </d-row>
    <d-row>
      <d-col cols="2" md="2" lg="6">
        <div class="form-group">
          <label for="patient-phone">
            Telefon:
          </label>
          <validation-provider
            rules="required|min:9"
            name="patient-phone"
            v-slot="{ errors }">
            <d-input
              id="patient-phone"
              type="number"
              v-model="data.phone"
              :state="errors.length ? 'invalid' : null" />
            <div class="invalid-feedback">
              {{ errors[0] }}
            </div>
          </validation-provider>
        </div>
      </d-col>
      <d-col cols="2" md="2" lg="6">
        <div class="form-group">
          <label for="patient-email">
            E-mail:
          </label>
          <validation-provider
            rules="required|email"
            name="patient-email"
            v-slot="{ errors }">
            <d-input
              id="patient-email"
              type="email"
              v-model="data.email"
              :state="errors.length ? 'invalid' : null" />
            <div class="invalid-feedback">
              {{ errors[0] }}
            </div>
          </validation-provider>
        </div>
      </d-col>
      <d-col>
        <div class="form-group">
          <label for="patient-institution-id">
            Placówka:
          </label>
          <validation-provider
            name="patient-institution-id"
            v-slot="{ errors }">
            <div
              :class="{
                'form-control': true,
                'is-select': true,
                'is-invalid': errors.length
              }">
              <v-select
                placeholder="Wybierz placówkę"
                :options="allInstitutions"
                v-model="data.institution_id"
                :reduce="institution => institution.id"
                label="name">
              </v-select>
            </div>
            <div class="invalid-feedback">
              {{ errors[0] }}
            </div>
          </validation-provider>
        </div>
      </d-col>
    </d-row>
    <d-row class="border-top pt-5 mt-5">
      <d-col cols="2" md="2" lg="6">
        <div class="form-group">
          <label for="patient-school-type">
            Typ szkoły:
          </label>
          <validation-provider
            rules="required"
            name="patient-school-type"
            v-slot="{ errors }">
            <div
              :class="{
                'form-control': true,
                'is-select': true,
                'is-invalid': errors.length
              }">
              <v-select
                :options="allSchoolTypes"
                :reduce="obj => obj.id"
                v-model="data.school_type"
                placeholder="Wybierz typ szkoły..."
                label="name">
              </v-select>
            </div>
            <div class="invalid-feedback">
              {{ errors[0] }}
            </div>
          </validation-provider>
        </div>
      </d-col>
    </d-row>
    <d-row>
      <d-col cols="2" md="2" lg="6">
        <div class="form-group">
          <label for="patient-school-name">
            Nazwa szkoły:
          </label>
          <validation-provider
            :rules="{required: data.school_type !== 'below_school' && data.school_type !== 'no_school'}"
            name="patient-school-nam"
            v-slot="{ errors }">
            <d-input
              id="patient-school-name"
              type="text"
              v-model="data.school_name"
              :state="errors.length ? 'invalid' : null" />
            <div class="invalid-feedback">
              {{ errors[0] }}
            </div>
          </validation-provider>
        </div>
      </d-col>
      <d-col cols="2" md="2" lg="6">
        <div class="form-group" v-if="data.school_type !== 'below_school' && data.school_type !== 'no_school' && data.school_type !== 'zero_school'  && data.school_type !== 'preschool'">
          <label for="patient-school-class">
            Klasa:
          </label>
          <validation-provider
            :rules="{required: data.school_type !== 'below_school' && data.school_type !== 'no_school' && data.school_type !== 'zero_school'  && data.school_type !== 'preschool'}"
            name="patient-school-class"
            v-slot="{ errors }">
            <d-input
              id="patient-school-class"
              type="text"
              v-model="data.school_class"
              :state="errors.length ? 'invalid' : null" />
            <div class="invalid-feedback">
              {{ errors[0] }}
            </div>
          </validation-provider>
        </div>
      </d-col>
    </d-row>
    <d-row>
      <d-col cols="2" md="2" lg="6">
        <div class="form-group">
          <label for="patient-school-city">
            Miejscowość szkoły:
          </label>
          <validation-provider
            :rules="{required: data.school_type !== 'below_school' && data.school_type !== 'no_school'}"
            name="patient-school-city"
            v-slot="{ errors }">
            <d-input
              id="patient-school-city"
              v-model="data.school_city"
              :state="errors.length ? 'invalid' : null" />
            <div class="invalid-feedback">
              {{ errors[0] }}
            </div>
          </validation-provider>
        </div>
      </d-col>
      <d-col cols="2" md="2" lg="6">
        <div class="form-group">
          <label for="patient-school-postcode">
            Kod pocztowy szkoły:
          </label>
          <validation-provider
            :rules="{required: data.school_type !== 'below_school' && data.school_type !== 'no_school'}"
            name="patient-school-postcode"
            v-slot="{ errors }">
            <d-input
              id="patient-school-postcode"
              v-model="data.school_postcode"
              :state="(errors.length) ? 'invalid' : null" />
            <div class="invalid-feedback">
              {{ errors[0] }}
            </div>
          </validation-provider>
        </div>
      </d-col>
    </d-row>
    <d-row>
      <d-col cols="3" md="3" lg="6">
        <div class="form-group">
          <label for="patient-school-street">
            Ulica szkoły:
          </label>
          <validation-provider
            :rules="{required: data.school_type !== 'below_school' && data.school_type !== 'no_school'}"
            name="patient-school-street"
            v-slot="{ errors }">
            <d-input
              id="patient-school-street"
              v-model="data.school_street"
              :state="errors.length ? 'invalid' : null" />
            <div class="invalid-feedback">
              {{ errors[0] }}
            </div>
          </validation-provider>
        </div>
      </d-col>
      <d-col cols="3" md="3" lg="3">
        <div class="form-group">
          <label for="patient-school-street-number">
            Numer ulicy szkoły:
          </label>
          <validation-provider
            :rules="{required: data.school_type !== 'below_school' && data.school_type !== 'no_school'}"
            name="patient-school-street-number"
            v-slot="{ errors }">
            <d-input
              id="patient-school-street-number"
              v-model="data.school_street_number"
              :state="errors.length ? 'invalid' : null" />
            <div class="invalid-feedback">
              {{ errors[0] }}
            </div>
          </validation-provider>
        </div>
      </d-col>
      <d-col cols="3" md="3" lg="3">
        <div class="form-group">
          <label for="patient-school-street-local-number">
            Numer lokalu szkoły:
          </label>
          <validation-provider
            v-slot="{ errors }">
            <d-input
              id="patient-school-street-local-number"
              type="text"
              format="[0-9]{2}\-[0-9]{3}"
              v-model="data.school_street_local_number"
              :state="errors.length ? 'invalid' : null" />
            <div class="invalid-feedback">
              {{ errors[0] }}
            </div>
          </validation-provider>
        </div>
      </d-col>
    </d-row>
    </validation-observer>
    <d-row class="border-top pt-5 mt-5">
      <d-col cols="2" md="2" lg="6">
        <div class="form-group">
          <label for="patient-school-type">
            Historia numeracji:
          </label>
          <ul>
            <li
              v-for="(patientNumber, indexNumber) of data.historical_patient_numbers"
              :key="'patient-number-data-' + indexNumber">Pacjent w roku {{ patientNumber.year }} był przypisany do numeru {{ patientNumber.display_number }}</li>
          </ul>
        </div>
      </d-col>
    </d-row>
    <d-row>
      <d-col
        col
        sm="7"
        class="text-right text-sm-right d-flex justify-content-end align-items-end mt-5">
        <d-button
          theme="success"
          @click.prevent="validateForm">
          Zapisz zmiany
        </d-button>
      </d-col>
    </d-row>

    <div v-if="!allDataLoaded" class="pb-3 pt-3 text-center">
      Trwa ładowanie danych&hellip;
    </div>

    <d-alert
      v-if="loadError"
      show
      theme="warning">
      Wczytywanie danych nie powiodło się.
      <a
        href="javascript:window.location.reload();"
        class="alert-link">Odśwież stronę
      </a>
      aby spróbować ponownie.
    </d-alert>

    <pesel-preview-popup
      :isVisible="showModal"
      :patient="selectedPatient"
      :loading="peselPreviewLoading"
      :onClosePopup="() => showModal = false"
      @fill="fillPatientData"
      @refresh="refreshSelectedPatient"
    />
  </div>
</template>

<script>
import Vue from 'vue';
import FormUtils from '@/utils/FormUtils.js';
import SexTypes from '@/data/sex-types.js';
import PeselSearch from '@/components/others/PeselSearch.vue';
import PeselPreviewPopup from '@/components/others/PeselSearchShowPopup.vue';

export default {
  name: 'patients-form-general',
  props: {
    allInstitutions: {
      type: Array,
      required: true
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    isVisible: {
      type: Boolean,
      default: false
    },
    patient: {
      type: Object,
      required: true
    }
  },
  components: {
    'pesel-search': PeselSearch,
    'pesel-preview-popup': PeselPreviewPopup
  },
  computed: {
    allDataLoaded () {
      return this.loaded && this.allSchoolTypes;
    },
    sexType () {
      return SexTypes;
    },
  },
  watch: {
    'isVisible': function (newValue) {
      if (newValue && !this.allDataLoaded) {
        Vue.set(this, 'loaded', true);
        this.loadAdditionalData();
      }
    }
  },
  data () {
    return {
      data: {
        id: '',
        birthday_date: '',
        city: '',
        email: '',
        institution_id: '',
        last_name: '',
        name: '',
        number_home: '',
        number_local: '',
        pesel: '',
        phone: '',
        place_of_birth: '',
        post_code: '',
        school_city: '',
        school_class: '',
        school_name: '',
        school_postcode: '',
        school_street: '',
        school_street_local_number: '',
        school_street_number: '',
        school_type: '',
        sex: '',
        street: '',
        historical_patient_numbers: []
      },
      peselOptions: [],
      peselLoading: false,
      allSchoolTypes: [],
      allSchoolTypesLoaded: false,
      loaded: false,
      loadError: false,
      showModal: false,
      selectedPatient: null,
      peselPreviewLoading: false,
    }
  },
  mounted () {
    let dataKeys = Object.keys(this.data);
    for (let i = 0; i < dataKeys.length; i++) {
      this.data[dataKeys[i]] = this.patient[dataKeys[i]] || this.data[dataKeys[i]];
    }
    if (this.isVisible) {
      this.loadAdditionalData();
      Vue.set(this, 'loaded', true);
    }
  },
  methods: {
    async searchByPesel(pesel) {
      if (!pesel) {
        this.peselOptions = [];
        return;
      }
      this.peselLoading = true;
      try {
        const response = await this.$http.post('/patients/search-by-pesel', { pesel });
        if (response.data.success) {
          this.peselOptions = Array.isArray(response.data.item)
            ? response.data.item
            : [response.data.item];
        }
      } catch (error) {
        this.peselOptions = [];
      } finally {
        this.peselLoading = false;
      }
    },
    refreshSelectedPatient() {
      this.peselPreviewLoading = true;

      FormUtils.submit(this, {
        endpoint: `/patients/update/${this.data.id}`,
        formData: this.data,
        successTitle: 'Zapisano pacjenta',
        successText: 'Dane pacjenta zostały zaktualizowane',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Aktualizacja danych pacjenta nie powiodła się. Spróbuj ponownie.',
        successAction: () => {
          this.peselPreviewLoading = false;
          this.showModal = false;
        },
        errorAction: () => {
          this.peselPreviewLoading = false;
          this.showModal = false;
        }
      });
    },
    openModal(patient) {
      this.selectedPatient = patient;
      this.showModal = true;
    },
    fillPatientData(patient) {
      const fields = [
        'name', 'last_name', 'birthday_date', 'place_of_birth',
        'city', 'post_code', 'street', 'number_home', 'number_local',
        'phone', 'email', 'school_name', 'school_type', 'school_class',
        'school_city', 'school_postcode', 'school_street',
        'school_street_number', 'school_street_local_number', 'institution_id'
      ];

      fields.forEach(field => {
        if (patient[field] !== undefined && patient[field] !== null) {
          this.data[field] = patient[field];
        }
      });

      this.showModal = false;
    },
    loadAdditionalData() {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/patients/school-types',
        outputKey: 'allSchoolTypes',
        loadedKey: 'allSchoolTypesLoaded',
        errorKey: 'loadError',
        method: 'GET',
        noPagination: true
      });
    },
    validateForm() {
      this.$bus.$emit('submit-patient-form');
    },
    getPatientData() {
      return this.data;
    }
  }
}
</script>
